__webpack_require__.p = "https://mosaic.ask-ai.co/";